import { mapState } from 'vuex'
import ozToggle from '@/components/oz-toggle'
import { priceFieldsMapper } from '@/utils/transformers/filters/prices'

export default {
  name: 'oz-toggle-total-price',

  props: {
    filters: {
      type: Object,
      required: true,
    },
    prices: {
      type: Object,
      required: true,
    },
    rentTotalPrice: { type: Boolean },
  },

  data () {
    return {
      initialValue: false,
    }
  },

  created () {
    this.initialValue = this.rentTotalPrice
  },

  computed: {
    ...mapState({
      loading: (state) => state.results.loading,
    }),
  },

  methods: {
    onRentTotalPriceChange (rentTotalPrice) {
      const { min, max } = this.prices

      if (!min && !max) {
        this.$store.commit('results/setFilters', { ...this.filters, rentTotalPrice })
        return
      }

      const prices = priceFieldsMapper(rentTotalPrice, { min, max })
      this.$emit('filters:update', { ...prices, rentTotalPrice })
    },
  },

  components: {
    ozToggle,
  },
}
